const BASE_URL = process.env.VUE_APP_BASE_URL;
const TIME_OUT = 10000;

export { BASE_URL, TIME_OUT };
